module.exports = {
    neoData: () => {
        return[
            {
            "Logo":require("./../../UI/general/Sidebar/logos-motos/tvs-neo-nx.svg"),
            "Motos":[
                {
                    "Nombre":"Neo NX 110",
                    "Logo":require('./../../UI/general/Sidebar/btns-motos/neo/neo.svg'),
                    "Foto":require('./../../UI/general/Sidebar/btns-motos/neo/neo-moto.png')
                }
            ]
            }
        ]
    }
}